import './error-modal.scss';
import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { ApiError } from './api-error/api-error';
import { observer } from 'mobx-react';
import errorModalStore from './error-modal-store';

interface IProps {}

export const ErrorModal: React.FC<IProps> = observer(() => {
    const el = useRef(document.createElement('div'));
    const parentElement = document.body;

    useEffect(() => {
        parentElement.appendChild(el.current);
        const elem = el.current;
        return () => {
            elem?.parentNode?.removeChild(elem);
        }
    }, [parentElement])

    return createPortal(
        (
            <div className="error-modal">
                { errorModalStore.list.map(err => (
                    <ApiError key={err.id} error={err} />
                )) }
            </div>
        ),
        el.current
    );
});


